import { render, staticRenderFns } from "./MembershipTable.vue?vue&type=template&id=8164b74a"
import script from "./MembershipTable.vue?vue&type=script&lang=ts"
export * from "./MembershipTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports